import { DefaultRequest } from 'scripts/api';
import {
  FILTER_EQUIPMENT_VISIBILITY_DEFAULT,
  FILTER_EQUIPMENT_VISIBILITY_OPTIONS
} from 'react/components/RouteMonitor/EquipmentStatusCaption/constants';
import { SEVEN_DAYS_IN_MILLISECONDS } from 'react/utils/utils';

class RouteMonitorRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'RouteMonitor';

        super(entityName);

        this.map = "";
        this.routeLayer = "";
        this.collection = {};
        this.stops = {};
        this.orders = {};
        this.lineItems = {};
        this.events = {};
        this.eventsClear = {};
        this.eventsByTime = {};
        this.routeStatus = {};
        this.markers = {};
        this.pois = {};
        this.arrayClearEvents = {};
        this.closeActions = [];
    }

    show = () => {

        var getGeofences = function() {
            var tagsAction = new Greenmile.Toolbar.Map.TagsGeofenceActions(Monet.Session.mainMap.map);
            var callback = function() {
                var checkedTags = tagsAction.getOptionSelected().map(function(i) {
                    return i.id;
                });
                if(checkedTags.length) {
                    tagsAction.getGeofenceByTags(checkedTags, tagsAction);
                }

            };

            if(!Monet.Session.TagList || !Monet.Session.TagList.Geofence) {
                var selector = ".routeMonitorRightPanelBody";
                tagsAction.setSelector(selector);
                tagsAction.requestTags(callback);
            }else {
                callback();
            }
        };

        var getPOIs = function() {
            var map = Monet.Session.mainMap.map;
            var layer = new Greenmile.Toolbar.Map.POISControl('.routeMonitorRightPanelBody', map),
                savedPOIsList = new Greenmile.Storage.StoreMapPosition().getPOIsMarked();

            if(savedPOIsList && savedPOIsList.length) {
                layer.addListeners();
                layer.clearAllPOIsMarker();
                layer.getPoisByType(savedPOIsList);
            }
        };

        var callback = function () {

          if (Monet.Security.checkKeyIsEnabled(['TRACKER_ROUTE_LIST'])) {
            if(!document.querySelector('#Maps .routeMonitorRightPanel')) {
              App.Objects.RouteMonitorRightPanel = new Greenmile.RouteMonitor.RightPanel();
              App.Objects.RouteMonitorRightPanel.init();
            }
            getGeofences();
            getPOIs();
            App.Objects.EventNotifications.getEvents();
          }

        };

        if (!document.querySelector("#mapContainer")) {
            delete App.Routers.RouteMonitor.markers;
        }

        this.checkHtmlBaseStructure(callback);

        return this;

    }

    checkHtmlBaseStructure = (callback) => {
        const renderToolbar = () => {
          const selector = '#Maps #mapToolbar';
          const maps = Monet.Session.mainMap.map;
          const options = {
            layersToEnable: [{
              layer: Greenmile.Toolbar.MapLayers.PENDING_ORDERS
            }]
          };
          const helper = new Monet.UI.Help('Maps', Monet.I18n.getResourcesByKey('VehiclesTracker'));
          const toolbar = new Greenmile.Toolbar.Map(maps, selector, options, helper);

          toolbar.enable([
            toolbar.actions.multiSearchOnMap,
            toolbar.actions.street,
            toolbar.actions.fitToMarkers,
            toolbar.actions.zoom,
            toolbar.actions.source,
            toolbar.actions.points,
            toolbar.actions.multiroute
          ]);
          toolbar.render();
        };
        App.Objects.RouteMonitor.startMap();
        renderToolbar();
        callback();
    }

    startMap = () => {

        Monet.Session.mainMap = Monet.Session.mainMap || {};
        const map = Greenmile.Map.Utility.createDefaultMap('mapContainer');
        const baseLayer = Greenmile.Map.Utility.createBaseLayer();
        map.addLayer(baseLayer);

        $("#alertEventUrgentInMap").prepend('<div class="detailErrorException"><div id="conteinerEventUrgent"></div></div>');

        map.on("zoomend", function () {
            Monet.Session.mainMap.map.invalidateSize();
        });

        //armazena a referência do baseLayer
        Monet.Session.mainMap.mapBaseLayer = baseLayer;

        Monet.Session.mainMap.map = map;

        if (typeof(App.Routers.RouteMonitor.prototype.layerFocus) === "undefined") {

            App.Routers.RouteMonitor.prototype.layerFocus = new L.MarkerClusterGroup({
                spiderfyOnMaxZoom: true,
                disableClusteringAtZoom: 2,
                zIndexOffset: 1,
                spiderfyDistanceMultiplier: 3
            });

        }

        this.getEquipmentPositionsByOrganizations();
    }

    pushOrganizationAndLabel = (acc, curr, infoMarkerActions) => {
      const organizationId = curr.organization.id;
      const labelToMarker = infoMarkerActions.getInfoMarkerSelectedByOrganizationId(organizationId);
      const hasVisibility = curr.hasVisibility;

      if(!hasVisibility) {
        return acc;
      }

      return [...acc, {
        organizationId,
        labelToMarker,
      }];
    }

    getChildOrganizations = (organizationArray, child, infoMarkerActions) => {
      if(!child) {
        return organizationArray;
      }
      else {
        let children = child.reduce((acc, curr) => {
          return this.getChildOrganizations(
            this.pushOrganizationAndLabel(acc, curr, infoMarkerActions),
            curr.childOrganizations,
            infoMarkerActions
          );
        }, []);
        return [...organizationArray, ...children];
      }
    }

    getOrganizationsRecursevely = (organizations, infoMarkerActions) => {
      let array = organizations.reduce((acc, curr) => {
        return this.getChildOrganizations(
          this.pushOrganizationAndLabel(acc, curr, infoMarkerActions),
          curr.childOrganizations,
          infoMarkerActions
        );
      }, []);
      return array;
    }

    getEquipmentPositionsByOrganizations = () => {
      const url = "Coordinate/RecentCoordinatesSummary";
      const organizations = Monet.Session.ApplicationLoad.organizationsHierarchy;
      const infoMarkerActions = new Greenmile.Toolbar.ConfigInfoMarkerTruckActions();
      const organizationsAndLabels = this.getOrganizationsRecursevely(organizations, infoMarkerActions);
      const storedTags = new Greenmile.Storage.StoreMapPosition().getEquipmentsTagsMarked();
      const tagsIds = storedTags.map((i) => i.id);
      const equipmentVisibilityFilterOption =
        new Greenmile.Storage.StoreMapPosition().getEquipmentVisibilityFilterOption();

      const data = {
        organizationsAndLabels,
        tagsIds,
      };

      this.getEquipmentPositions(url, data, equipmentVisibilityFilterOption);
    }

    getEquipmentPositions = (url, requestBody, equipmentVisibilityFilterOption = FILTER_EQUIPMENT_VISIBILITY_DEFAULT) => {

        const map = Monet.Session.mainMap.map;
        const markersToAdd = [];

        if (!Monet.Session.Maps) {
            Monet.Session.Maps = {};
            Monet.Session.Maps.mainMap = {};
            Monet.Session.Maps.mainMap.markers = {};
            Monet.Session.Maps.EquipmentsTag = {};
        }

        function filterByDateOption(equipmentArray, option) {
          if (!Array.isArray(equipmentArray)) return [];
          if (option === FILTER_EQUIPMENT_VISIBILITY_OPTIONS.SHOW_ALL) return equipmentArray;
          const now = new Date();
          let minDate = null;
          if (option === FILTER_EQUIPMENT_VISIBILITY_OPTIONS.ACTIVE_LAST_7_DAYS) {
            minDate = new Date(now.getTime() - SEVEN_DAYS_IN_MILLISECONDS);
          }
          if (!minDate) return equipmentArray;
          return equipmentArray.filter(eq => {
            if (!eq.date && eq.coordinate?.date) {
                eq.date = eq.coordinate.date;
            }
            if (!eq.date) return false;
            const eqDate = new Date(eq.date);
            return eqDate >= minDate && eqDate <= now;
          });
        }

        const callback = (equipmentArray) => {
            const filteredEquipmentArray = filterByDateOption(equipmentArray, equipmentVisibilityFilterOption);

            const points = [];
            const markerLayer = App.Routers.RouteMonitor.markers;

            if (!Monet.Session.Maps) {

                Monet.Session.Maps = {};
                Monet.Session.Maps.mainMap = {};
                Monet.Session.Maps.mainMap.markers = {};
                Monet.Session.Maps.EquipmentsTag = {};

            } else {
                Monet.Session.Maps.mainMap.markers = {};
            }

            if (Monet.Session.map) {
                Monet.Session.map.removeLayer(markerLayer);
            }

            if (!Monet.Session.Maps.mainMap.truckStatus) {
                Monet.Session.Maps.mainMap.truckStatus = {
                    noCommunication: "noCommunication",
                    turnedOff: "turnedOff",
                    moving: "moving",
                    stopped: "stopped"
                };
            }

            if (!Monet.Session.Maps.mainMap.truckStatusFilter) {
                Monet.Session.Maps.mainMap.truckStatusFilter = {
                    noCommunication: true,
                    turnedOff: true,
                    moving: true,
                    stopped: true
                };
            }

            const markers = this.initializeClusterGroup(map);

            for (let i = 0, j = filteredEquipmentArray.length; i < j; i++) {
                this.createNumberedDivIcon();
                const marker = this.createIMakerByInfoConfigured(filteredEquipmentArray[i], "EQUIPMENT");
                if (Monet.Security.checkKeyIsEnabled(['TRACKER_EQUIPMENT_ROUTE_STATUS'])) {
                    this.addClickEventToMarker(marker);
                    this.bindPopupToMarker(marker);
                }
                const markerToPutInMap = this.pushMarkerToMap(markers, marker);
                if (markerToPutInMap) {
                    markersToAdd.push(markerToPutInMap);
                }
                points.push([
                  filteredEquipmentArray[i].coordinate.position.latitude,
                  filteredEquipmentArray[i].coordinate.position.longitude
                ]);
            }

            markers.addLayers(markersToAdd);
            if (window.GreenmileReduxStore) {
                window.GreenmileReduxStore.dispatch({
                    type: 'GREENMILE_ROUTEMONITOR_REQUEST'
                });
            }

            this.storeMapInMonetSession(map);
            this.focusMap(points);
            this.addFocusAndDragBehavior(map);

        };

        if (Monet.Security.checkKeyIsEnabled(['TRACKER_MAP'])) {
            const ajax = new Monet.Ajax();
            ajax.url = url;
            ajax.method = 'POST';
            ajax.data = requestBody;
            ajax.success = (data) => {
                Monet.Session.Maps.EquipmentsTag.allTrucks = data;
                callback(data);
            };
            ajax.send();
        }
    }

    initializeClusterGroup = (map) => {

        var htmlGraphicCluster = function (cluster) {

            if (Greenmile.Platform.browser) {

                Greenmile.Platform.check();

            }

            var clusterStatus = Greenmile.ClusterEquipmentStatus.read(cluster);
            var leaflet_cluster_id = cluster._leaflet_id;
            var total_result_status = clusterStatus[leaflet_cluster_id].moving
                + clusterStatus[leaflet_cluster_id].noComunication
                + clusterStatus[leaflet_cluster_id].stopped
                + clusterStatus[leaflet_cluster_id].turnedOf;

            var total = total_result_status;
            var noComunication = clusterStatus[leaflet_cluster_id].noComunication;
            var moving = clusterStatus[leaflet_cluster_id].moving;
            var stopped = clusterStatus[leaflet_cluster_id].stopped;
            var turnedOf = clusterStatus[leaflet_cluster_id].turnedOf;

            /*calcuclo do pecental*/
            var percent_noComunication = (noComunication / total) * 100;
            var percent_moving = (moving / total) * 100;
            var percent_stopped = (stopped / total) * 100;
            var percent_turnedOf = (turnedOf / total) * 100;

            var obj = {
                total: total,
                percents: {
                    noCommunication: percent_noComunication,
                    moving: percent_moving,
                    stopped: percent_stopped,
                    turnedOf: percent_turnedOf
                },
                absolutes: {
                    noCommunication: noComunication,
                    moving: moving,
                    stopped: stopped,
                    turnedOf: turnedOf
                }
            };

            return Greenmile.GeneratePieChart.createPie(obj);

        };

        var markers = App.Routers.RouteMonitor.markers;

        if (!markers) {
            markers = new L.MarkerClusterGroup({
                iconCreateFunction: (cluster) => {

                    var icon = new L.DivIcon({
                        html: htmlGraphicCluster(cluster)
                    });

                    return icon;
                },
                spiderfyDistanceMultiplier: 3
            });

            App.Routers.RouteMonitor.markers = markers;

        }

        map.addLayer(markers);

        markers.clearLayers();

        return markers;
    }

    createNumberedDivIcon = () => {
        L.NumberedDivIcon = L.Icon.extend({

            createIcon: function() {
                var div = document.createElement('div');
                var img = this._createImg(this.options['iconUrl']);
                var numdiv = document.createElement('div');

                numdiv.setAttribute("class", "markerLabel");

                var divMarkerText = "";

                divMarkerText += '<div class="leaflet-popup-pane">';
                divMarkerText += '<div class="leaflet-label  leaflet-zoom-animated ' + this.options['status'] + '" style="opacity: 1;" >';
                divMarkerText += this.options['number'] || '';
                divMarkerText += '</div>';
                divMarkerText += '</div>';

                numdiv.innerHTML = divMarkerText;

                div.appendChild(img);
                div.appendChild(numdiv);

                this._setIconStyles(div, 'icon');

                return div;
            },

            // you could change this to add a shadow like in the normal marker
            // if you really wanted
            createShadow: () => {
                return null;
            }

        });
    }

    getTruckStatus = (equipment) => {

        var isEquipmentEngineOn = this.isEquipmentEngineOn(equipment);
        var isEquipmentMoving = this.isEquipmentMoving(equipment);
        var lastTransmission = this.getLastEquipmentTransmissionInMinutes(equipment);
        var markerStatus = "";

        if (isEquipmentEngineOn === false) {
            markerStatus = Monet.Session.Maps.mainMap.truckStatus.turnedOff;
        } else if (lastTransmission > 40) {
            markerStatus = Monet.Session.Maps.mainMap.truckStatus.noCommunication;
        } else if (isEquipmentMoving) {
            markerStatus = Monet.Session.Maps.mainMap.truckStatus.moving;
        } else {
            markerStatus = Monet.Session.Maps.mainMap.truckStatus.stopped;
        }

        return markerStatus;
    }

    getLastEquipmentTransmissionInMinutes = (equipment) => {
        var coordinateDate = Monet.Format.DateTime.parse(equipment.date).getTime();
        var now = new Date().getTime();
        var timeDifference = parseInt(((now - coordinateDate) / 1000) / 60);

        return timeDifference;
    }

    isEquipmentMoving = (equipment) => {
        var speedKmh = equipment.speedKmh;
        return (speedKmh > 5);
    }

    isEquipmentEngineOn = (equipment) => {
        return equipment.engineOn;
    }

    getMarkerClass = (truckStatus) => {
        switch (truckStatus) {
            case Monet.Session.Maps.mainMap.truckStatus.noCommunication:
                return "truckWithoutCommunication";
            case Monet.Session.Maps.mainMap.truckStatus.turnedOff:
                return "truckOff";
            case Monet.Session.Maps.mainMap.truckStatus.moving:
                return "truckOnAndMoving";
            default:
                return "truckOnAndStopped";
        }
    }

    getIconDriver = () => {
        return require('static/images/map/markers/driver_marker.png');
    }

    getIconByStatusRoute = (status) => {

        var icon;

        switch (status) {
            case 'STARTED':
                icon = require('static/images/map/markers/route_started_marker.png');
                break;
            case 'NOT_STARTED':
                icon = require('static/images/map/markers/route_not_started_marker.png');
                break;
            case 'DEPARTED_ORIGIN':
                icon = require('static/images/map/markers/in_route_marker.png');
                break;
            case 'ARRIVED_ORIGIN':
                icon = require('static/images/map/markers/arrived_destination_marker.png');
                break;
            default :
                icon = '';
        }

        return icon;

    }

    getTruckIcon = () => {
        return require('static/images/map/markers/marker_truck.png');
    }

    getInfoByConfiguration = (equipment) => {

      const markerInfo = new Greenmile.Toolbar.ConfigInfoMarkerTruckActions();
      const infoConfigured = markerInfo.getInfoMarkerSelectedByOrganizationId(equipment.coordinate.organizationId);
      const { markerLabel, routeKey, routeStatus } = equipment;
      let icon = '';
      let number = '';

      switch (infoConfigured) {

        case 'DRIVER':
        case 'DRIVER_KEY':
        case 'DRIVER_NAME':
        case 'ROUTE_DRIVER_NAME':
          icon = this.getIconDriver();
          number = markerLabel;
          break;

        case 'ROUTE':
          icon = this.getIconByStatusRoute(routeStatus);
          number = routeKey;
          break;

        case 'EQUIPMENT':
        default:
          icon = this.getTruckIcon();
          number = markerLabel;
          break;

      }

      return { icon, number };

    }

    createIMakerByInfoConfigured = (equipment, kind) => {

        var info = this.getInfoByConfiguration(equipment);
        var coordinate = equipment.coordinate;
        var truckStatus = this.getTruckStatus(coordinate);
        var statusClass = this.getMarkerClass(truckStatus);

        var marker = L.marker([
            coordinate.position.latitude,
            coordinate.position.longitude], {
            icon: new L.NumberedDivIcon({
                number: info.number,
                status: statusClass,
                iconUrl: info.icon,
                iconSize: [20, 20],
                iconAnchor: [10, 10],
                popupAnchor: [-6, 5]
            }),

            zIndexOffset: 0
        });

        marker.kind = kind;
        marker.status = truckStatus;
        marker.coordinates = coordinate;

        return marker;
    }

    addClickEventToMarker = (marker) => {

        marker.on("click", function () {

            Monet.Session.Maps.mainMap.marker = this;

            const request = new DefaultRequest({
                url: "Equipment/" + this.coordinates.equipmentId + "/RouteStatus",
                success: function (data) {

                    data.idIsLink = true;

                    var driversInfo = [];
                    var mkr = Monet.Session.Maps.mainMap.marker.coordinates;
                    var unit = Monet.Session.User;
                    var keyKmH = "Greenmile.UnitMetrics.kilometersPerHour";
                    var keyMih = "Greenmile.UnitMetrics.milesPerHour";
                    var numDecimal = " " + Monet.I18n.getResourcesByKey(keyKmH);
                    var km = mkr.speedKmh;
                    var telematicList = [];
                    var gpsProfileTelematicProfile;
                    var renderedTemplate;

                    if (unit.unitSystem === "NON_METRIC") {

                        if (!mkr.speedKmh) {
                            mkr.speedKmh = 0;
                        }

                        km = mkr.speedKmh * 0.62137;

                        numDecimal = " " + Monet.I18n.getResourcesByKey(keyMih);

                    }

                    if (data && data.driversInfo) {

                        var serverDriversInfo = data.driversInfo;

                        for (var i = 0; i < serverDriversInfo.length; i++) {

                            var driver = { name: serverDriversInfo[i].name };
                            var phones = serverDriversInfo[i].phoneInfos;

                            var strPhones = "";

                            for (var j = 0; j < phones.length; j++) {

                                strPhones += phones[j].phone + " / ";

                            }
                            strPhones = strPhones.substr(0, strPhones.length - 3);

                            driver.phones = strPhones;
                            driversInfo.push(driver);
                        }

                    }

                    if (!data.equipment) {
                        data.equipment = {};
                        data.equipment.id = mkr.equipmentId;
                    }

                    if (data.totalStops) {

                        data.delivered = (data.totalArrivesStops / data.totalStops) * 100 + '%';
                        data.backLater = (data.totalRedeliveryStops / data.totalStops) * 100 + '%';
                        data.returnStops = (data.totalCancelStops / data.totalStops) * 100 + '%';
                        data.deliveryProgress = data.totalArrivesStops + data.totalRedeliveryStops + data.totalCancelStops + '/' + data.totalStops + ' (' + parseInt(((data.totalArrivesStops + data.totalRedeliveryStops + data.totalCancelStops) / data.totalStops) * 100, 10) + '%)';

                    } else if (data.totalStops === 0) {

                        data.delivered = 0;
                        data.backLater = 0;
                        data.returnStops = 0;
                        data.deliveryProgress = '0/0 (0%)';

                    }

                    gpsProfileTelematicProfile = data.equipment.gpsProviderTelematicProfile;

                    if (gpsProfileTelematicProfile) {

                        var telemeticProps = gpsProfileTelematicProfile.gpsProviderTelematicProps;

                        if (telemeticProps && telemeticProps.length) {

                            var telematicCoord = mkr.telematic;

                            var formatValuesByType = function (type, value) {

                                var valueFormatted = "";

                                if (type === 'BOOLEAN') {

                                    if (value) {
                                        valueFormatted = Monet.I18n.getResourcesByKey('Greenmile.Telematic.valueBooleanTrue');
                                    } else {
                                        valueFormatted = Monet.I18n.getResourcesByKey('Greenmile.Telematic.valueBooleanFalse');
                                    }

                                } else {
                                    valueFormatted = value;
                                }

                                return valueFormatted;

                            };

                            if (telematicCoord) {
                                for (var k = 0; k < telemeticProps.length; k++) {

                                    var telemetic = telemeticProps[k];

                                    if (telematicCoord[telemetic.key]) {
                                        telematicList.push({
                                            description: Monet.I18n.getResourcesByKey(telemetic.description),
                                            value: formatValuesByType(telemetic.type, telematicCoord[telemetic.key])
                                        });
                                    }

                                }
                            }

                        }
                    }

                    renderedTemplate = Greenmile.Templates.getLeafletPopUp({
                        marker: mkr,
                        request: data,
                        velocityKm: km.toFixed(2),
                        unitDecimal: numDecimal,
                        driversInfo: driversInfo,
                        telematicList: telematicList
                    });
                    Monet.Session.Maps.mainMap.marker._popup.setContent(
                      renderedTemplate
                    );
                }
            });
            request.send();
        });

        Monet.Session.Maps.mainMap.markers[marker.coordinates.equipmentId] = marker;
    }

    bindPopupToMarker = (marker) => {
        const point = new L.Point(43, 5);
        const panPoint = new L.Point(100,100);
        const image = require("static/images/general/loading_blue.svg");
        marker.bindPopup(
          '<div style="height:350px;"><img src="' +
            image +
            '" width="50" style="margin-left: -25px; margin-top: -25px; left: 50%; top: 50%; opacity: 0.5; position:absolute;"></div>',
          {
            offset: point,
            minWidth: 371,
            maxWidth: 500,
            autoPan: true,
            autoPanPaddingTopLeft: panPoint
          }
        );
    }

    pushMarkerToMap = (markers, marker) => {

        var noCommunication = Monet.Session.Maps.mainMap.truckStatusFilter.noCommunication;
        var turnedOff = Monet.Session.Maps.mainMap.truckStatusFilter.turnedOff;
        var moving = Monet.Session.Maps.mainMap.truckStatusFilter.moving;
        var stopped = Monet.Session.Maps.mainMap.truckStatusFilter.stopped;

        if (marker.status === Monet.Session.Maps.mainMap.truckStatus.noCommunication && noCommunication === true) {
            return marker;
        } else {
            if (marker.status === Monet.Session.Maps.mainMap.truckStatus.turnedOff && turnedOff === true) {
                return marker;
            } else {
                if (marker.status === Monet.Session.Maps.mainMap.truckStatus.moving && moving === true) {
                    return marker;
                } else if (marker.status === Monet.Session.Maps.mainMap.truckStatus.stopped && stopped === true) {
                    return marker;
                }
            }
        }

        return false;

    }

    storeMapInMonetSession = (map) => {
        Monet.Session.Maps.map = map;
    }

    focusMap = (points) => {

        var mapStorage = new Greenmile.Storage.StoreMapPosition();
        var mapValues = mapStorage.getPosition();
        var map = Monet.Session.mainMap.map;

        if (mapValues && mapValues.center.lat && mapValues.center.lng) {

            var ll = L.latLng(mapValues.center.lat, mapValues.center.lng);
            Monet.Session.mainMap.map.setView(ll, mapValues.zoom);

        } else { // Se não, foca no bound dos elementos da tela.

            if (points && points.length) {
                map.fitBounds(points);
            }

            var maps = new App.Routers.RouteMonitor();
            maps.storageMapValues();
        }
    }

    addFocusAndDragBehavior = (map) => {
        map.on("zoomend", function () {
            var mapsRoute = new App.Routers.RouteMonitor();
            mapsRoute.storageMapValues();
        });

        map.on("dragend", function () {
            var mapsRoute = new App.Routers.RouteMonitor();
            mapsRoute.storageMapValues();
        });
    }

    showMarkerInformation = (text) => {

        $(".markerInformation").html(text);

        return this;
    }

    setMap = (mapValue) => {
        Monet.Session.mainMap.map = mapValue;
    }

    getMap = () => {
        return Monet.Session.mainMap.map;
    }

    storageMapValues = () => {
        var mainMapZoom = Monet.Session.mainMap.map.getZoom();
        var mainMapLatLng = Monet.Session.mainMap.map.getCenter();

        var mapStorage = new Greenmile.Storage.StoreMapPosition();
        mapStorage.setPosition(mainMapLatLng, mainMapZoom);
    }

    addCloseAction = (action) => {
        this.closeActions.push(action);
    }

    removeCloseAction = (actionToRemove) => {
        this.closeActions = this.closeActions.filter((action) => action !== actionToRemove);
    }

    onClose = () => {
        this.closeActions.forEach((action) => action());
    }
}

App.Routers.RouteMonitor = RouteMonitorRouter;
